var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"Box"},[_c('img',{staticClass:"image",attrs:{"src":"https://mendian.changgongwang.cn/uploads/kaquan/kaquan.png","alt":""}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }